import { render, staticRenderFns } from "./ProjectCardWrapper.vue?vue&type=template&id=6f15a0ff"
import script from "./ProjectCardWrapper.vue?vue&type=script&lang=ts"
export * from "./ProjectCardWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f15a0ff')) {
      api.createRecord('6f15a0ff', component.options)
    } else {
      api.reload('6f15a0ff', component.options)
    }
    module.hot.accept("./ProjectCardWrapper.vue?vue&type=template&id=6f15a0ff", function () {
      api.rerender('6f15a0ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectCardWrapper.vue"
export default component.exports